<template>
  <div class="readViewer cover" :style="`height:${heightValue}px`">
<!--    <LeftBar v-show="showBar" :total="total" :currentIndex="currentIndex" :bookInfo="bookInfo" @changePage="changePage"
      @getSearch="getSearch" :innerSearchStatus="innerSearchStatus" @getPageList="getPageList" />-->
    <div :class="['showFlag1',{hiddenFlag:!showBar}]">
      <!--    <div v-show="showBar" @click="showBar=false"><i class="el-icon-d-arrow-left"></i></div>-->
      <div @click="showBar=true" class="normalModel">目录</div>
    </div>
    <RightContainer ref="rightContainer" :pageArr="pageArr" @setCurrentIndex="setCurrentIndex"
      @getBookInfo="getBookInfo" :searchText="searchText" @currentSearch="currentSearch"></RightContainer>
  <div :class="['showFlag',{hiddenFlag:!showBar}]">
<!--    <div v-show="showBar" @click="showBar=false"><i class="el-icon-d-arrow-left"></i></div>-->
<!--    <div v-show="showBar" @click="showBar=false" class="simbolModel">隐藏目录</div>-->
<!--    <div v-show="!showBar" @click="showBar=true" class="normalModel">一般模式</div>-->
  </div>
    <div class="dialogNav" v-show="showBar">
      <el-dialog title="" :visible.sync="showBar" width="300px" :modal="false" :show-close="true" :close-on-click-modal="false">
        <LeftBar v-show="showBar" :total="total" :currentIndex="currentIndex" :bookInfo="bookInfo" @changePage="changePage"
                 @getSearch="getSearch" :innerSearchStatus="innerSearchStatus" @getPageList="getPageList" />
      </el-dialog>
    </div>

  </div>
</template>

<script>
import LeftBar from './components/left.vue'
import RightContainer from './components/rightContainer.vue'
import { getBookPageInfoApi } from '@/api/api'
import eventBus from "@/utils/eventBus.js"
export default {
  components: { LeftBar, RightContainer },
  data () {
    return {
      heightValue: 0,
      total: 0,
      currentIndex: 0,
      searchText: '',
      // 0未处理 1搜索有数据 2暂无数据
      innerSearchStatus: 0,
      pageArr: [],
      bookInfo: {},
      showBar:false
    }
  },
  mounted () {
    // 获取头尾高度
    const headerHeight = document.getElementsByClassName('header-bg')[0].offsetHeight
    const footerHeight = document.getElementsByClassName('footer')[0].offsetHeight
    const windowHeight = window.innerHeight
    //this.heightValue = windowHeight - headerHeight - footerHeight
    this.heightValue = windowHeight - headerHeight

    const { params, query } = this.$route
    let bookId = 0
    if (this.$route.query && this.$route.query.bookId) {
      bookId = this.$route.query.bookId
    }
    this.loadingPage=true
    getBookPageInfoApi({ bookId }).then(res => {
      if(res.code==200){
        this.pageArr = res.data
        this.currentIndex=0
      }else{
        this.$message({
          message: res.msg,
          type: 'warning'
        });
      }
    })
  },
  methods: {
    getBookInfo (data) {
      this.bookInfo = data
      eventBus.$emit("getBookDetail",{
        bookName:data.bookName,
        writer:data.writer,
        bookVersion:data.bookVersion,
      })
    },
    getSearch (val) {
      this.searchText = val
    },
    getTotal (data) {
      this.total = data
    },
    changePage (val) {
      this.$refs.rightContainer.setpage(val)
    },
    setCurrentIndex (data) {
      this.currentIndex = data
    },
    currentSearch (data) {
      this.innerSearchStatus = data
    },
    getPageList (data) {
      this.pageArr = data
    }
  }
}
</script>
<style lang="less">
.h-full {
  height: 100%;
}
</style>
<style lang="less" scoped>
.dialogNav{
  /deep/.el-dialog{
    margin: 0;
    margin-top: 85px !important;
  }
  /deep/.el-dialog__body{
    padding: 0;
  }
  /deep/.el-dialog__header{
    padding: 0;
  }
  /deep/.el-dialog__wrapper{
    right: auto;
    bottom: auto;
  }
}

@PingFangSC-Regular: PingFangSC-Regular;
.readViewer {
  display: flex;
  width: 100%;
  height: calc(100vh - 6.26rem);
  overflow: hidden;
  background: #f4f0e8;
  padding: 20px;
  position: relative;
  .showFlag{
    position: absolute;
    left: 220px;
    top:30px;
    font-size: 14px;
    .simbolModel {
      width: 86px;
      height: 27px;
      line-height: 27px;
      cursor: pointer;
      background: #fff;
      border: 1px solid #795636;
      border-radius: 4px;
      font-family: @PingFangSC-Regular;
      font-size: 12px;
      color: #795636;
      letter-spacing: 0;
      text-align: center;
      font-weight: 400;
    }
    .normalModel{
      width: 25px;
      height: 110px;
      line-height: 27px;
      cursor: pointer;
      background: #fff;
      border: 1px solid #795636;
      border-radius: 4px;
      font-family: @PingFangSC-Regular;
      font-size: 12px;
      color: #795636;
      letter-spacing: 0;
      text-align: center;
      font-weight: 400;
    }
  }
  .showFlag1{
    .normalModel{
      padding-top: 5px;
      width: 25px;
      height: 50px;
      margin-right: 10px;
      line-height: 20px;
      cursor: pointer;
      background: #fff;
      border: 1px solid #795636;
      border-radius: 4px;
      font-family: @PingFangSC-Regular;
      font-size: 12px;
      color: #795636;
      letter-spacing: 0;
      text-align: center;
      font-weight: 400;
    }
  }
  .hiddenFlag{
    left: 25px;
  }
}
</style>



// WEBPACK FOOTER //
// src/view/read/index.vue